module.exports = __webpack_public_path__ + "img/bgc24.713a6e98.png";